import { render, staticRenderFns } from "./scanCard.vue?vue&type=template&id=e2745222&scoped=true&"
import script from "./scanCard.vue?vue&type=script&lang=js&"
export * from "./scanCard.vue?vue&type=script&lang=js&"
import style0 from "./scanCard.vue?vue&type=style&index=0&id=e2745222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2745222",
  null
  
)

export default component.exports